import { CroppingPatternReportModel } from "@agroyaar/sdk";
import { ColumnChartData } from "@/shared/components/charts/ColumnChart";

export function mapIndexToChartData(
  reports: CroppingPatternReportModel[],
  key: keyof Pick<
    CroppingPatternReportModel,
    | "soilAdaptabilityIndex"
    | "profitabilityIndex"
    | "climaticAdaptabilityIndex"
    | "irrigationRequirementIndex"
  >
): ColumnChartData[] {
  return reports.map((r) => ({
    name: r.crop.persianName,
    value: r[key] as number,
  }));
}
